<basic-input
  #dateInput
  [control]="control"
  [icon]="icon"
  [label]="label"
  [id]="id"
  [required]="isRequired"
  [placeholder]="placeholder"
  [fieldType]="basicFieldType"
  [mode]="mode"
  [type]="'date'"
  [addValidationColors]="true"
  [allowClearButton]="allowClearButton"
  [min]="getMinDateString()"
  [max]="getMaxDateString()"
  (onBlurValueChange)="onBlur($event)"
  (onValueChange)="onDateChange($event)"
  (onFocusInput)="openDatePicker()"
>
</basic-input>
